import { render, staticRenderFns } from "./ReceiptsGraph.vue?vue&type=template&id=882de75a&scoped=true&"
import script from "./ReceiptsGraph.vue?vue&type=script&lang=js&"
export * from "./ReceiptsGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882de75a",
  null
  
)

export default component.exports